import {getParameterByName} from "../util";

const defaultState = {
	inApp: null
};

export default function(state = defaultState, action) {
	switch (action.type) {
		case 'LOGIN':
			return state.inApp===null ?
				{
					...state,
					inApp: getParameterByName('inapp')==='true'
				} : state;
		default:
			return state;
	}
}